module.exports = __webpack_public_path__ + "static/media/solid_caret-down.a6b5fad8.svg";